import Grid from '@material-ui/core/Grid'
import * as PropTypes from 'prop-types'
import React from 'react'
import IDSYNAutocomplete from './idsynAutoComplet'

export const IdsynInput = () => {
  return (
    <Grid item xs={6}>
      <IDSYNAutocomplete label={'IDSYN'} name="idsyn" multiple freeSolo />
    </Grid>
  )
}

IdsynInput.propTypes = {
  className: PropTypes.string,
  idcc: PropTypes.string,
  onChange: PropTypes.func,
  isLabel: PropTypes.bool,
}
